// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f3b28854","732":"f8ade7a3","977":"0691fca1"}[chunkId] + ".chunk.js";
};